import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { XCircle } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useToast } from "@/hooks/use-toast"

export default function Cancel() {
  const navigate = useNavigate()
  const { toast } = useToast()

  useEffect(() => {
    toast({
      variant: "destructive",
      title: "Payment Cancelled",
      description: "Your payment was cancelled. Please try again if you'd like to complete your purchase.",
    })
  }, [toast])

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="flex justify-center mb-4">
          <XCircle className="h-16 w-16 text-destructive" />
        </div>
        <h1 className="text-4xl font-bold mb-4">Payment Cancelled</h1>
        <p className="text-xl text-muted-foreground mb-8">
          Your payment was cancelled. You can try again whenever you're ready.
        </p>
        <Button onClick={() => navigate("/")}>Return to Pricing</Button>
      </div>
    </div>
  )
}